import React, { useEffect, useState } from "react";
import {
    Typography,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton
} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import { useQuery } from "@apollo/client";
import { connect } from "react-redux";
import queryHistory from "../../lib/queryHistroy";
import DraggableTable from "../common/DraggableTable";
// import CloseIcon from "@material-ui/icons/Close";
// import { withStyles } from "@material-ui/core/styles";
import { signupPlansByModuleIdByPaginationQuery } from "../plans/signupPlansGQLQuery";

const defaultSorted = [
  {
    id: "plan_name",
    desc: false,
  },
];
const defaultPageSize = 20;
const defaultPage = 1;

const PlansInUseList = (props) => {

//   const moduleFunctionalityByModuleIdRefetchOnCall=()=>{
//     signupPlansQryRefetch()    
//   }

  // useEffect(()=>{    
    // props.bindModuleFunctionalityByModuleIdRootQueryRefetchOnCall(moduleFunctionalityByModuleIdRefetchOnCall)
  // },[moduleFunctionalityByModuleIdRefetchOnCall])

  
//   const { classes } = props;
 
  
  const [signupPlansList, setSignupPlansList] = useState([]);
  const [pages, setPages] = useState(defaultPage);
  let [sortedArray, setSortedArray] = useState(defaultSorted);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  let [currentPage, setCurrentPage] = useState(0);
  const [openModuleDetail, setOpenModuleDetail] = useState(false);
  const [ moduleData, setModuleData] = useState(0);


  const {
    data: signupPlansData,
    loading: signupPlansQryLoading,
    refetch : signupPlansQryRefetch,
  } = useQuery(signupPlansByModuleIdByPaginationQuery, {
    variables: {
      moduleId: parseInt(props.moduleId),
      sortedBy: defaultSorted,
      limit: defaultPageSize,
      offset: defaultPage,
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {    
    if (
        !signupPlansQryLoading &&
      signupPlansData &&
      signupPlansData.signupPlansByModuleIdByPaginationQuery 
    ) {
      setSignupPlansList(
        signupPlansData.signupPlansByModuleIdByPaginationQuery.signupPlans
      );
      setPages(
        signupPlansData.signupPlansByModuleIdByPaginationQuery
          ? Math.ceil(
              signupPlansData
                .signupPlansByModuleIdByPaginationQuery.rowCount / pageSize
            )
          : 1
      );
    } else {
      setSignupPlansList([]);
    }
  }, [signupPlansData]);

  const columns = [
    {
      HeaderText: "Plan Name",
      Header: (props) => (
        <div className="draggable-header">
          <span className="reactTable-headerText">
            {"Plan Name"} 
            {sortedArray &&
              sortedArray.filter((iName) => iName.id === "plan_name").length >
                0 && <Icon className="sortableArrow">arrow_right_alt</Icon>}
          </span>
        </div>
      ),
      id: "plan_name",
      Cell: (props) => {
        return (
          <span className="flex items-center capitalize">
              {props.original.planName}
            </span>
        );
      },
      sortable: true,
      multiSort: true,
    },
    {
      HeaderText: "Industry Name",
      Header: (props) => (
        <div className="draggable-header">
          <span className="reactTable-headerText">
            {"Industry Name"}
            {sortedArray &&
              sortedArray.filter((iName) => iName.id === "industry_display_name")
                .length > 0 && (
                <Icon className="sortableArrow">arrow_right_alt</Icon>
              )}
          </span>
        </div>
      ),
      id: "industry_display_name",
      Cell: (props) => {
        return (
          <>
            <span className="flex items-center capitalize">
              {props.original.industryDisplayName}
            </span>
          </>
        );
      },
      sortable: true,
      multiSort: true,
    },
    {
      HeaderText: "Price",
      Header: (props) => (
        <div className="draggable-header">
          <span className="reactTable-headerText">{"Price"}</span>
        </div>
      ),
      Cell: (props) => {
        return (
          <>
            <span className="flex items-center capitalize">
              {props.original.signupPlanPriceList.length ? props.original.signupPlanPriceList
                .filter((j) => j.commitment === "NO COMMITMENT")
                .map(
                  (i, idx) =>
                    "$ " +
                    i.price +
                    " " +
                    i.renewal.charAt(0) +
                    i.renewal.slice(1).toLowerCase()
                )
                .join(" / ") : ""}
            </span>
          </>
        );
      },
      sortable: false,
      multiSort: false,
    },
    {
      Header: "Published",
      Cell: (props) => {
        return (
          <>
            <span className="flex items-center capitalize">
              {props.original.isPublished ? "Yes" : "No"}
            </span>
          </>
        );
      },
      sortable: false,
      multiSort: false,
    },
  ];

  const getData = async (pageSize, page) => {
    let newQueryVariables = {
      moduleId: parseInt(props.moduleId),
      sortedBy: sortedArray,
      limit: pageSize,
      offset: page,
    };

    let historyFilters = {
      moduleId: parseInt(props.moduleId),
      sortedBy: sortedArray,
      limit: pageSize,
      offset: page,
    };
    queryHistory.set(
      props,
      "signupPlansQryRefetch",
      historyFilters
    );
    signupPlansQryRefetch(newQueryVariables);
  };

  
  const fetchData = (state, instance) => {
    let activePage =
          state.pageSize === pageSize && state.page ? state.page + 1 : 1;
    
    sortedArray = state.sorted;
    setSortedArray(state.sorted);
    currentPage = activePage - 1;
    setCurrentPage(activePage - 1);
    getData(state.pageSize, activePage);
  };


   var height = (props.height || window.innerHeight) - 40;
  return (
    <>
    <div style={{ padding: 8 }} className="reactTableWraper">
      <DraggableTable
        manual // Forces table not to paginate or sort automatically, so we can handle it server-side
        pages={pages} // Display the total number of pages
        loading={signupPlansQryLoading} // Display the loading overlay when we need it
        onFetchData={fetchData} // Request new data when things change
        data={signupPlansList}
        expanderDefaults={{ width: 0 }}
        columns={columns}
        resizable={true}
        noDataText="No Record Found"
        minRows={1}
        defaultSorted={sortedArray}
        pageSizeOptions={[20, 25, 50, 100]}
        defaultPageSize={pageSize}
        pageSize={pageSize}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        onPageSizeChange={(sz) => {
          setCurrentPage(0);
          setPageSize(sz);
        }}
        multiSort={true}
        style={{
          maxHeight: height,          
          cursor: "default",
        }}      
      />
    </div>
        </>
  );
};

const mapStateToProps = ({}) => {
  return {};
};

export default connect(mapStateToProps)(PlansInUseList);
